(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("circleprogress", [], factory);
	else if(typeof exports === 'object')
		exports["circleprogress"] = factory();
	else
		root["circleprogress"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 